module.exports = __webpack_public_path__ + "img/能源异常管理.68a83a8a.png";